exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-gallery-carousel1 .VueCarousel{max-height:100%}.media-gallery-carousel1 .VueCarousel-dot-container{margin:0 !important;width:100% !important;display:-ms-flexbox !important;display:flex !important;-ms-flex-pack:center !important;justify-content:center !important}.media-gallery-carousel1 .VueCarousel-dot-container .VueCarousel-dot{width:13px !important;height:13px !important;outline:none !important;padding:20px 8px !important;margin:0 !important;border-radius:0 !important}@media (max-width: 767px){.media-gallery-carousel1 .VueCarousel-dot-container .VueCarousel-dot{padding:5px 8px !important}}\n", ""]);

// exports
